const getAlign = (align: string) => {
  switch (align) {
    case "Izquierda":
      return "left";
    case "Centro":
      return "center";
    case "Derecha":
      return "right";
    default:
      return "left";
  }
};

export default getAlign;
